import { render, staticRenderFns } from "./formss.vue?vue&type=template&id=91546f00&"
import script from "./formss.vue?vue&type=script&lang=js&"
export * from "./formss.vue?vue&type=script&lang=js&"
import style0 from "./formss.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports